<template>
	<div>
	  <SubTopNav :title="title" :image="image" />
	  <div class="people content">

		<div>
			<div v-html="content"></div>
			<div class="row">
				<div class="contact-map col-xl-4 col-sm-12">
					<GmapMap
					  :center="{lat:9.072264, lng:7.491302}"
					  :zoom="4.5"
					  map-type-id="terrain"
					  style="width: 100%; height: 100%; xmin-height:100vh;"
					  ref="map"
					>

					  <GmapMarker
					    :key="index"
					    v-for="(m, index) in markers"
					    :position="m.position"
					    :clickable="true"
					    :draggable="true"
					    @click="center=m.position"
					  />
					</GmapMap>
				</div>
				<div class=" col-xl-8 col-sm-12">
					<div class="person-grid">
						<div v-for="(person, index) in people.slice().reverse()" :key="index" class="person" :id="'person-'+person.nid[0].value">
							<h2>{{ person.title[0].value }}</h2>
							<div class="person-body animated fadeIn">
								<div v-html="person.body[0].value"></div>
							</div>
						</div>
						
					</div>
					<b-button @click="showModal({component:'WebformEmbedModal', title: 'Contact Us', footer: false, hideLogo: true, embedId: 'contact_us'})" variant="secondary" class="btn-lg btn-block">Contact Us &raquo;</b-button>
					<p>&nbsp;</p>
				</div>
			</div>
		</div>	    		
	  </div>
	  

	
  </div>
</template>
<script>
// @ is an alias to /src
	import { mapActions } from 'vuex' 
	import SubTopNav from "@/components/SubTopNav.vue";
	import { RepositoryFactory } from "@/repositories/RepositoryFactory"
  	const ContentRepository = RepositoryFactory.get("content");

	export default {
	  name: "people",
	  components: {
	    SubTopNav
	  },
	  data: function(){
	  	return {
	  		content: null,
	  		image: null,
	  		currentPerson:null,
	  		people: [],
	  		title:null,
	  		markers: []
	  	}
	  },
	  methods: {
	  	async getPeoplePage(){
	  		var type = "page"
	        var id = "25"
	        const { data } = await ContentRepository.get(type, id)

	        if (data.length > 0){
	          if (data[0].body.length > 0){
        		this.content = data[0].body[0].value
        	  }

        	  if (data[0].title[0].value){
        	  	this.title = data[0].title[0].value
        	  }
	          if (data[0].field_page_header_image.length > 0){
	          	this.image = data[0].field_page_header_image[0].url
	          }
	          
	        }
	  		},
	  		async getPeople(){
		  		var type = "location"
		        var id = "all"
		        const { data } = await ContentRepository.get(type, id)

		        if (data.length > 0){

		          this.people = data
		          var location = ''

		          for (var i = 0; i < this.people.length; i++){
		          	location = this.people[i]
		          	if (location.field_latitude && location.field_longitude && location.field_latitude.length > 0 && location.field_longitude.length > 0){
		          		this.markers.push({position: {lat: location.field_latitude[0].value, lng: location.field_longitude[0].value}})
		          	}
		          }

		          // console.log('markers', this.markers)

		        }
	  		},
	  		...mapActions(['showModal'])
	  },
	  mounted(){
	  	this.getPeoplePage()
	  	this.getPeople()
	  }
	};
</script>
<style scoped>
	.people{
		text-align:left;
		margin-left:5%;
	}

	.profile-pic{
		float:left;
		margin-right:25px;
		margin-bottom:25px;
	}

	.left-column{
		margin-bottom:25px;
	}

	.person{
		/*width:150px;
		height:150px;*/
		padding:15px 0px 15px 15px;
		text-transform:uppercase;
		font-weight:bold;
		xcolor:#FFF;
		xbackground:#999;
		border-left:2px solid #333;
		border-top:2px solid #333;
		xmin-height:125px;
		cursor:pointer;
		margin-bottom:25px;
		/*display:inline-block;*/
	}

	.person h2{
		font-size:20px;
		font-weight:bold;
	}

	.person-body{
		text-transform:none;
		xfont-size:15px !important;
		font-weight:normal;
		position:relative;
		z-index:-5;
	}

	.current-person{
		background:rgba(255, 255, 255, 0.95);
		position:absolute;
		/*width:100%;
		height:100vh;*/
		top:0;
		left:0;
		right:0;
		bottom:0;
		height:100vh;
		padding:50px;
		text-align:left;
		z-index:500;
	}

	.close-icon{
		float:right;
		cursor:pointer;
		margin-right:-25px;
		margin-top:-25px;
	}

	.person:hover{
		xbackground:#FFFF00;
	}

	.position{
		font-family:"Tahoma", "Avenir", Helvetica, Arial, sans-serif;
		font-size:60%;
		font-weight:normal;
	}

	.person-grid{
		display:grid;
		grid-template-columns: 1fr 1fr;
		grid-gap:25px;
	}

	.page-image img{
		max-width:100%;
	}

	.page-image{
		background-size:cover;
	}

	.square{
		width:50%;
		overflow:hidden;
	}

	.square.blue{
		xclear:both;
		float:left;
		background:rgba(0,102,255,0.8);
	}

	.square.green{
		background:rgba(0,153,51,0.8);
		float:right;
	}

	.square.yellow{
		background:rgba(255,255,0,0.8);
		clear:both;
		margin-bottom:20px;
	}

	.contact-map{
		min-height:400px;
		margin-bottom:30px;
	}

	.square:after {
	  content: "";
	  display: block;
	  padding-bottom: 100%;
	}

	@media (max-width:768px){
		.person-grid{
			grid-template-columns: 1fr;
		}
	}


</style>
